'use strict';

/**
 * Pict-Provider-PhotoAPI
 * ----------------------
 * Browser-side client for profile photos. The server re-encodes whatever is
 * uploaded into a display JPEG plus a 128px avatar thumb (see
 * ProfilePhoto-Endpoint.js), so the client just PUTs the raw File and reads the
 * blob back through an <img> (same-origin cookie auth). photoURL() carries the
 * PhotoHash as a cache-buster so a freshly changed avatar shows immediately.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'PhotoAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderPhotoAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') tmpPrefix += '/';
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	/**
	 * URL for a user's photo. pThumb requests the 128px avatar; pVersion (the
	 * PhotoHash) busts the browser cache when the photo changes.
	 */
	photoURL(pIDUser, pThumb, pVersion)
	{
		let tmpQuery = [];
		if (pThumb) { tmpQuery.push('thumb=1'); }
		if (pVersion) { tmpQuery.push('v=' + encodeURIComponent(pVersion)); }
		return this._url('Profile/Photo/' + pIDUser) + (tmpQuery.length ? ('?' + tmpQuery.join('&')) : '');
	}

	/** PUT the raw image File. Resolves with { PhotoHash }. */
	uploadPhoto(pFile)
	{
		let tmpMime = (pFile && pFile.type) || 'application/octet-stream';
		return libFrameworkClient.uploadBinary(this.fable, this._url('Profile/Photo'), pFile, tmpMime, 'PUT')
			.then((pBody) =>
			{
				let tmpBody = pBody || {};
				if (!tmpBody.Success) { throw new Error(tmpBody.Error || 'Photo upload failed.'); }
				return tmpBody;
			});
	}

	deletePhoto()
	{
		return libFrameworkClient.delJSON(this.fable, this._url('Profile/Photo'))
			.then((pBody) => pBody || { Success: true });
	}
}

module.exports = PictProviderPhotoAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
